/** Tiny pub/sub for cross-cutting API signals (offline banner, 401 handling). */

type Listener = () => void

const unauth = new Set<Listener>()
const netListeners = new Set<Listener>()
let networkDown = false

export function onUnauthenticated(listener: Listener) {
  unauth.add(listener)
  return () => {
    unauth.delete(listener)
  }
}

export function reportUnauthenticated() {
  unauth.forEach((l) => l())
}

export function reportNetworkFailure() {
  if (!networkDown) {
    networkDown = true
    netListeners.forEach((l) => l())
  }
}

export function reportNetworkSuccess() {
  if (networkDown) {
    networkDown = false
    netListeners.forEach((l) => l())
  }
}

export function subscribeNetwork(listener: Listener) {
  netListeners.add(listener)
  return () => {
    netListeners.delete(listener)
  }
}

export function getNetworkDown() {
  return networkDown
}
